import { MenuItem, withStyles } from '@material-ui/core';

export const NkMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
  },
}))(MenuItem);
